import { render } from "./MdCardActions.vue?vue&type=template&id=2a08130b"
import script from "./MdCardActions.vue?vue&type=script&lang=js"
export * from "./MdCardActions.vue?vue&type=script&lang=js"

import "./MdCardActions.vue?vue&type=style&index=0&id=2a08130b&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__